import React from "react"
import { useRecoilState } from "recoil"
import currentUser from "../store/currentUser"
import { Auth, API, graphqlOperation } from "aws-amplify"
import { updateUser as UpdateUser } from "../graphqlCustom/mutations"
import { useHistory, Link as RouterLink } from "react-router-dom"
import { useSnackbar } from "notistack"
import { makeStyles } from "@material-ui/styles"
import Grid from "@material-ui/core/Grid"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import useFormFields from "../libs/useFormFields"

import Button from "../components/Button"
import TextField from "../components/TextField"

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    margin: "auto",
    marginTop: theme.spacing(1),
    maxWidth: 600,
  },
}))

export default function ChangePassword() {
  const classes = useStyles()
  const [isLoading, setIsLoading] = React.useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [user, setUser] = useRecoilState(currentUser)
  const [fields, handleFieldChange] = useFormFields({
    email: user.email,
    phone: user.phone,
  })

  function validateForm() {
    return fields.email.length > 0
  }

  async function handleSubmit(event) {
    event.preventDefault()
    setIsLoading(true)

    try {
      const authUser = await Auth.currentAuthenticatedUser()
      await Auth.updateUserAttributes(authUser, {
        email: fields.email,
      })
      await API.graphql(
        graphqlOperation(UpdateUser, {
          input: {
            id: user.id,
            email: fields.email,
            phone: fields.phone,
          },
        })
      )
      setUser({
        ...user,
        email: fields.email,
        phone: fields.phone,
      })
      enqueueSnackbar("Contact successfully updated", {
        variant: "success",
      })
      history.push("/0/profile")
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar("Contact could not be updated", {
        variant: "error",
      })
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid className={classes.container} container spacing={3}>
        <Grid item xs={12}>
          <TextField onChange={handleFieldChange} value={fields.email} id="email" label="Email" />
        </Grid>
        <Grid item xs={12}>
          <TextField
            onChange={handleFieldChange}
            defaultValue={fields.phone}
            id="phone"
            label="Phone"
          />
        </Grid>
      </Grid>
      <Grid className={classes.container} container spacing={3} justifyContent="flex-end">
        <Grid item>
          <Button component={RouterLink} to="/0/profile" variant="text">
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={!validateForm()}
            endIcon={<ChevronRightIcon />}
            isLoading={isLoading}
            type="submit"
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}
